export const MenuClose = ({ style, className }) => {
    return (
        <svg 
        style={style}
        className={className}
        width="17" 
        height="16" 
        viewBox="0 0 17 16" 
        fill="none" 
        xmlns="http://www.w3.org/2000/svg">
        <rect width="20.5701" height="2.05701" rx="1" transform="matrix(0.707116 0.707098 -0.707116 0.707098 1.45459 0)" fill="#979797"/>
        <rect width="20.5701" height="2.05701" rx="1" transform="matrix(0.707116 -0.707098 0.707116 0.707098 0.00146484 14.5449)" fill="#979797"/>
        </svg>
    )
}